import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Tabs,
  Tab,
  Typography,
  Card,
  CardContent,
  MenuItem,
  IconButton,
} from "@mui/material";

import { useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";
import { iepaProd } from "../../constants/global";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const ViewLocations = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [activeTab, setActiveTab] = useState(0); // To manage active tab
  const navigate = useNavigate(); // For page navigation

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null); //Error
  const [savelocationId, setSavelocationId] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();

  const { selectedRows, locations } = location.state || {};

  // When selectedRows change, update the selectedLocation
  useEffect(() => {
    if (!!selectedRows && selectedRows.length === 1) {
      // Assuming selectedRows contains an array with one object that has an 'id' field
      const selectedId = selectedRows[0];
      const location = locations.find((p) => p.id === selectedId);
      setSelectedLocation(location);
      setSavelocationId(selectedId);
    } else {
      setSelectedLocation(null); // Reset if no product is selected
    }
  }, [selectedRows, locations]); // Re-run whenever selectedRows or products change

  // Handle dynamic initial values based on selectedLocation
  const initialValues = selectedLocation
    ? {
        locationId: selectedLocation ? selectedLocation.id || "" : "",
        locationCode: selectedLocation ? selectedLocation.code || "" : "",
        locationPincode: selectedLocation ? selectedLocation.zipCode || "" : "",
        locationName: selectedLocation ? selectedLocation.name || "" : "",
        //  stage: selectedLocation ? selectedLocation.stage || '' : '',
      }
    : {
        locationCode: "",
        locationPincode: "",
        locationName: "",
      };

  const handleClose = () => {
    navigate("/Locations"); // Redirect to /CustomerList
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleLocationFormSubmit = (values, { resetForm }) => {
    const data = {
      id: savelocationId,
      destinationName: values.locationName,
      code: values.locationCode,
      zipCode: values.locationPincode,
      orgId: "1",
      updatedBy: 1,
    };

    console.log("Send data");
    console.log(data);

    fetch(
      `${iepaProd.iepaInventorySrvAPI}/inventory/routes/destination/update`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setMessage("Location updated successfully!");
        setError(null);
        resetForm();
        console.log("Location Id:" + data.id);

        setSavelocationId(data.id);
      })
      .catch((error) => {
        setError("Failed to update Location. Please try again.");
        setMessage(null);
      });
  };


  useEffect(() => {
    setLoading(true);
  }, []);
  console.log("initialValues", initialValues);
  const tabContent = [
    {
      label: "Location Details",
      content: selectedLocation ? (
        <Formik
          initialValues={initialValues}
          validationSchema={overviewSchema}
          onSubmit={handleLocationFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log("values", values)}
              <Box display="flex" flexDirection="column" gap="20px" mt="20px">
                <TextField
                  fullWidth
                  required
                  id="locationCode"
                  label="Location Code"
                  value={values.locationCode || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.locationCode && Boolean(errors.locationCode)}
                  helperText={touched.locationCode && errors.locationCode}
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  fullWidth
                  required
                  id="locationName"
                  label="Location Name"
                  value={values.locationName || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.locationName && Boolean(errors.locationName)}
                  helperText={touched.locationName && errors.locationName}
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  fullWidth
                  id="locationPincode"
                  label="Location Pincode"
                  value={values.locationPincode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.locationPincode && Boolean(errors.locationPincode)
                  }
                  helperText={touched.locationPincode && errors.locationPincode}
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  fullWidth
                  id="stage"
                  label="Stage"
                  value={values.stage}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.stage && Boolean(errors.stage)}
                  helperText={touched.stage && errors.stage}
                  inputProps={{ readOnly: !isEditing }}
                />
              </Box>
              {isLoading && <p>Processing...</p>}{" "}
              {/* Show "Processing..." while loading */}
              {message && <div className="success-message">{message}</div>}
              {error && <div className="error-message">{error}</div>}{" "}
              {/* Error message */}
              <Box display="flex" gap={2} sx={{ mt: 3 }}>
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: colors.blueAccent[700],
                    color: colors.primary[400],
                    fontSize: "14px",
                    fontWeight: "bold",
                    margin: "10px",
                  }}
                  variant="contained"
                  disabled={!isEditing}
                >
                  Save
                </Button>

                <Button
                  // type="submit"
                  sx={{
                    backgroundColor: colors.blueAccent[700],
                    color: colors.primary[400],
                    fontSize: "14px",
                    fontWeight: "bold",
                    margin: "10px",
                  }}
                  variant="contained"
                  onClick={() => {
                    resetForm(); // Reset form when clicked
                  }}
                  disabled={!isEditing}
                >
                  Reset
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      ) : (
        <Typography>Loading...</Typography>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="View Location" subtitle="View/Edit Item Locations" />
      <Box display="flex" justifyContent="flex" mb="20px">
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", marginRight: "5px" }}
          >
            Close
          </Typography>{" "}
          <CloseIcon />
        </IconButton>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => setIsEditing(true)}
          // onClick={() => navigate("../ProductList")}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          Edit
        </Button>
      </Box>
      <Card>
        <CardContent>
          <Tabs value={activeTab} onChange={handleTabChange}>
            {tabContent.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                sx={{
                  color: activeTab === index ? "black" : colors.blueAccent[700], // Active tab color
                  fontWeight: activeTab === index ? "bold" : "normal", // Optional: Bold for active tab
                }}
              />
            ))}
          </Tabs>

          <Box mt="20px">{tabContent[activeTab].content}</Box>
        </CardContent>
      </Card>
    </Box>
  );
};

const overviewSchema = yup.object().shape({
  locationCode: yup.string().required("Location Code is required"),
  locationPincode: yup.string().required("Location Pincode is required"),
  locationName: yup.string().required("Location Name is required"),
});

export default ViewLocations;
